import { render, staticRenderFns } from "./contrastChart.vue?vue&type=template&id=2b6077dc&scoped=true"
import script from "./contrastChart.vue?vue&type=script&lang=js"
export * from "./contrastChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6077dc",
  null
  
)

export default component.exports